import {useEffect} from 'react';

export default function useGoogleFonts(fonts) {
  useEffect(() => {
    const storeFonts = window.IS_CHECKOUT_PAGE
      ? []
      : window.AVADA_FAQ?.widgetSetting?.fontStore?.map(x => x.value) || [];
    const appFonts = fonts.filter(x => x && !storeFonts.includes(x));
    loadGoogleFonts(appFonts);
  }, [fonts]);

  const loadGoogleFonts = fonts => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = `https://fonts.bunny.net/css?family=${fonts.join('|')}:400&display=swap`;
    document.head.appendChild(link);
  };
}
